import TravelTo from '../TravelTo';
import type { IConnectionLinkDetails } from '../../../../../../../../models/connection-link-details.model';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { ISelectedNonPublicTransportLink } from '../../../../models/selected-non-public-transport';
import { DateTimeHelper } from '../../../../../../../../helpers/date-time.helper';

function ConnectionLink({
  connectionLinkDetails,
  onConnectionLinkSelected,
}: {
  connectionLinkDetails: IConnectionLinkDetails;
  onConnectionLinkSelected: (selectedNonPublicTransport: ISelectedNonPublicTransportLink) => void;
}) {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href="#"
      className="connection-link text-decoration-none d-block btn--outline-internal"
      onClick={(e) => {
        e.preventDefault();
        onConnectionLinkSelected({ connectionLinkLegIndex: connectionLinkDetails.journeyLegIndex, arrivalAccessLink: false, departureAccessLink: false });
      }}
    >
      <span className="visually-hidden">{TranslationService.get('travelplanner.readmoreabouttripleg')}</span>
      <TravelTo
        transportMode={connectionLinkDetails.transportMode}
        durationInMinutes={DateTimeHelper.minutes(
          connectionLinkDetails.origin.estimatedTime || connectionLinkDetails.origin.plannedTime,
          connectionLinkDetails.destination.estimatedTime || connectionLinkDetails.destination.plannedTime
        )}
        distanceInMeters={connectionLinkDetails.distanceInMeters}
        showLinkIcon={true}
      ></TravelTo>
    </a>
  );
}

export default ConnectionLink;
